export const styles = {
  table: {
    fontFamily: "Novera,sans-serif",
    fontSize: 14,
    lineHeight: "20px",
    fontWeight: 400,
    "& .MuiDataGrid-footerContainer": {
      justifyContent: "center",
      backgroundColor: "white",
      height: 40,
    },
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: "#EEEEEE",
    },
    "& .MuiTablePagination-toolbar": {
      height: 40,
    },
    "& .MuiDataGrid-cell:focus , & .MuiDataGrid-withBorderColor:focus": {
      outline: "none",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "primary.light",
    },
    "& .MuiDataGrid-row": {
      backgroundColor: "mono.white",
    },
    "& .MuiDataGrid-columnHeaderTitleContainer": {
      whiteSpace: "unset",
    },
    "& .MuiDataGrid-columnHeaderTitle , & .MuiDataGrid-columnHeaderTitleContainerContent>.MuiTypography-root":
      {
        fontWeight: 800,
        color: "mono.grey.3",
      },
    "& .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)>.MuiDataGrid-cell":
      {
        whiteSpace: "unset",
        overflowWrap: "break-word",
      },
    "& .MuiDataGrid-sortIcon": {
      color: "#E87722",
    },
  },
};
